export interface ExportTask {
  id: number;
  taskName: string;
  taskType: string;
  status: number; // 1:Processing, 2:Completed, 3:Failed
  creatorId: number;
  filterParams: any;
  fileName?: string;
  fileUrl?: string;
  fileSize?: number;
  recordCount?: number;
  startedAt?: string;
  finishedAt?: string;
  errorMessage?: string;
  createdAt: string;
  updatedAt: string;
}

export const ExportStatus = {
  Processing: 1,
  Completed: 2,
  Failed: 3,
};

export const ExportStatusMap: Record<number, string> = {
  1: '进行中',
  2: '已完成',
  3: '失败',
};

export const ExportStatusColorMap: Record<number, string> = {
  1: 'processing',
  2: 'success',
  3: 'error',
};
